<template>
  <Layout>
    <PageHeader :title="title" :items="itemsPageHeader"></PageHeader>
    <b-row>
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col sm="8"></b-col>
            <b-col sm="4"> </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <div class="form-row form-group">
                <label class="col-md-2 col-form-label">ค้นหา</label>
                <div class="col-md-8">
                  <input
                    type="text"
                    placeholder="id / name / domain"
                    class="form-control"
                  />
                </div>
              </div>
            </b-col>
            <b-col md="4"> </b-col>
          </b-row>

          <b-row>
            <b-col lg="12" class="text-sm-right">
              <div class="button-items">
                <button
                  type="button"
                  class="btn btn-primary waves-effect"
                  @click="onFilter()"
                >
                  <i class="bx bx-search font-size-16 align-middle mr-2"></i>
                  Search
                </button>
                <button
                  type="button"
                  class="btn btn-light waves-effect"
                  @click="onReset()"
                >
                  <i class="bx bx-reset font-size-16 align-middle mr-2"></i>
                  Reset
                </button>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="12">
        <b-card>
          <b-row class="d-flex justify-content-between mb-2">
            <b-col cols="12" sm="6" md="4">
              <span>Show</span>
              <label class="d-inline-flex align-items-center">
                <b-form-select
                  v-model="pageSize"
                  size="sm"
                  :options="[10, 25, 50, 100, 200]"
                  class="ml-3"
                  @change="reLoad"
                >
                </b-form-select>
              </label>
              <span class="ml-2">entries</span>
            </b-col>
            <b-col cols="12" sm="6" md="4">
              <b-input-group>
                <template #prepend>
                  <b-input-group-text>
                    <i class="fas fa-search"></i>
                  </b-input-group-text>
                </template>
                <b-form-input
                  placeholder="Search"
                  v-model="search"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-table
                responsive
                :items="
                  items.map((it, index) => ({
                    ...it,
                    index: firstRowOnPage + index,
                  }))
                "
                class="table-centered table-nowrap"
                :empty-text="'No data found'"
                :show-empty="!items || (items && items.length == 0)"
                :bordered="true"
                :filter="search"
                align="center"
                :perPage="pageSize"
                :fields="fields"
                @filtered="onFiltered"
              >
                <template v-slot:cell(action)="">
                  <div class="text-center">
                    <a class="btn btn-ico text-info" title="View">
                      <i class="bx bx-show"> </i>
                    </a>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="4">
              <div style="position: relative; top: 7px">
                Showing {{ firstRowOnPage }} to {{ lastRowOnPage }} of
                {{ totalRecords }} entries
              </div>
            </b-col>
            <b-col lg="8">
              <b-pagination
                :total-rows="totalRecords"
                :per-page="pageSize"
                v-model="pageNo"
                @change="onClickPagination($event)"
                class="pagination pagination-rounded justify-content-end mb-2"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>

<script>
// load common
import PageHeader from "@/components/page-header.vue";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
// load package
import Multiselect from "vue-multiselect";
// load components

//load helper
import core from "@/helpers/client";
import { FormatQty } from "@/helpers/utils/format-qty.js";
import { FormatDate, FormatDateTime } from "@/helpers/utils/format-date.js";

export default {
  name: "ServiceClientApps",
  page: {
    title: "Service Client Apps",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    PageHeader,
    Layout,
    // Multiselect,
  },
  data() {
    return {
      title: "Service Client Apps",
      itemsPageHeader: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Service Client Apps",
          active: true,
        },
      ],
      fields: [
        {
          key: "index",
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0);
          },
          label: "ลำดับ",
          thStyle: "width:80px",
          sortable: false,
        },
        {
          key: "service_name",
          label: "Service Name",
          sortable: true,
        },
        {
          key: "service_domain",
          label: "Domain",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:80px",
        },
      ],
      items: [],
      pageNo: 1,
      pageSize: 25,
      hasNextPage: false,
      hasPreviousPage: false,
      totalPages: 0,
      totalRecords: 0,
      search: "",
      filter: {
        sort: null,
      },
    };
  },
  methods: {
    async getServiceDataAsync() {
      this.isLoading = true;
      // console.log(this.filter);
      let params = new URLSearchParams();
      if (this.filter.keyword) {
        params.append("keyword", this.filter.keyword);
      }
      /*  if (this.filter.Status || this.filter.Status.length > 0) {
        this.filter.Status.forEach((element) => {
          params.append("status", element);
        });
      }
      if (this.filter.Exchange) {
        params.append("exchange", this.filter.Exchange);
      }
      if (this.filter.dateFrom && this.filter.dateTo) {
        params.append("datefrom", this.filter.dateFrom);
        params.append("dateto", this.filter.dateTo);
      } */
      if (this.pageNo) {
        params.append("page", this.pageNo);
      }
      if (this.pageSize) {
        console.log(this.pageSize);
        params.append("pageSize", this.pageSize);
      }
      if (this.filter.sort) {
        params.append("sort", this.filter.sort);
      }
      params.append("allow_channels", "ClientApps");
     // console.log(params);
      const res = await core.fetch(
        `${process.env.VUE_APP_BASE_API}api/v1/services`,
        params
      );
      // console.log(res);
      if (res.status === 200) {
        this.items = res.data.items;
        // this.pageNo = res.data.pageNo;
        // this.pageSize = res.data.pageSize;
        this.hasNextPage = res.data.hasNextPage;
        this.hasPreviousPage = res.data.hasPreviousPage;
        this.totalPages = res.data.totalPages;
        this.totalRecords = res.data.totalRecords;
        this.isLoading = false;
      }
    },
    async onClickPagination(pageNo) {
      this.pageNo = pageNo;
      this.reLoad();
    },
    async onFiltered(filteredItems) {
      this.totalPages = filteredItems.length;
    },
    async onSearchClicked() {
      // console.log(this.filter);
      this.getServiceDataAsync();
    },
    onResetClicked() {
      this.search = "";
      const filter = {
        sort: null,
      };
      this.filter = filter;
    },
    async reLoad() {
      this.isLoading = true;
      await this.getServiceDataAsync();
      this.isLoading = false;
    },
  },
  created() {
    this.reLoad();
  },
  computed: {
    firstRowOnPage() {
      return 1 + (this.pageNo - 1) * this.pageSize;
    },
    lastRowOnPage() {
      return this.firstRowOnPage + this.items.length - 1;
    },
  },
};
</script>

<style lang="css" scoped></style>
